import { render, staticRenderFns } from "./shop-home.vue?vue&type=template&id=225c8713&scoped=true"
import script from "./shop-home.vue?vue&type=script&lang=js"
export * from "./shop-home.vue?vue&type=script&lang=js"
import style0 from "./shop-home.vue?vue&type=style&index=0&id=225c8713&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c8713",
  null
  
)

export default component.exports